<template>
  <div class="default-container">
    <img :src="$store.state.static_img_url + 'pic/quesheng-2.png'">
    <slot name="p"></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.default-container
  padding 120px 0
  text-align center
  p
    font-size 14px
    line-height 24px
    color #999
    margin-top 30px
  a
    color rgba(250, 122, 80, 1)
    text-decoration underline
</style>
